export enum Languages {
  English = 1,
  Spanish,
}
